"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OverlayDrawerSurface", {
    enumerable: true,
    get: function() {
        return _OverlayDrawerSurface.OverlayDrawerSurface;
    }
});
const _OverlayDrawerSurface = require("./OverlayDrawerSurface");
